module.exports = ".pagination {\n  margin-top: 0;\n  vertical-align: top; }\n\n.pager {\n  margin-top: 0;\n  margin-bottom: 5px; }\n\na {\n  cursor: pointer; }\n\nnav > div > .btn-default {\n  color: var(--brand-primary); }\n\n#paginacao-avancada {\n  color: var(--tertiaryColor); }\n\n@media (max-width: 768px) {\n  ul.pager {\n    margin-bottom: 15px; }\n    ul.pager li {\n      display: block;\n      clear: both; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/pagination/pagination.component.scss
// module id = ./src/app/common/pagination/pagination.component.scss
// module chunks = main